import React from 'react';
import { Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FGrid, FGridMoneyCell } from '../grid';

type Props = { rows:any[]; selectedId?:any; loading?:boolean; onSelect:(row:any)=>void };

class CAPackageGrid extends React.Component<Props> {
  columns:GridColDef[] = [
    {field:'shc', headerName:'Package Code', width:160},
    {field:'nam', headerName:'Package Title', flex:1, minWidth:260},
    {field:'fyr', headerName:'Year', width:90},
    {field:'pst', headerName:'Status', width:130, renderCell:(p)=><Chip size="small" label={p.value||'-'} />},
    {field:'bvi', headerName:'Budget Version', width:140},
    {field:'ppi', headerName:'PPM', width:100},
    {field:'tam', headerName:'Amount', width:150, renderCell:FGridMoneyCell},
  ];
  render(){return <FGrid title="CA Review Packages" rows={this.props.rows||[]} columns={this.columns} loading={this.props.loading} height={370} showQuickFilter toolbarSx={{backgroundColor:'#eaf2fb'}} getRowId={(r:any)=>r.rid||r.id} onRowClick={(p:any)=>this.props.onSelect(p.row)} getRowClassName={(p:any)=>String(p.row.rid||p.row.id)===String(this.props.selectedId)?'selected-ca-row':''} sx={{'& .selected-ca-row':{bgcolor:'#e3f2fd'},'& .MuiDataGrid-row':{cursor:'pointer'}}}/>;}
}
export default CAPackageGrid;
